import { render, staticRenderFns } from "./collection-bar.vue?vue&type=template&id=7e54ea3c&scoped=true&"
import script from "./collection-bar.vue?vue&type=script&lang=js&"
export * from "./collection-bar.vue?vue&type=script&lang=js&"
import style0 from "./collection-bar.vue?vue&type=style&index=0&id=7e54ea3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e54ea3c",
  null
  
)

export default component.exports